import React, { useRef, useEffect, useState } from 'react'
import './index.css'
import styled from 'styled-components'
import AppData from '../../../../model/AppData';
// const ICON_laba = require("../../../../images/icons/tongzhi.png");
import {
    Grid,
} from '@material-ui/core';


//左右跑马灯
function TextScroll(props) {
    const { content, duration } = props

    const defaultState = {
        contentWidth: 0,
        left: 0,
        duration,
    }

    const [state, setState] = useState(defaultState)

    let ref = useRef(null)

    useEffect(() => {
        const { offsetWidth, parentElement } = ref.current

        setState({
            ...state,
            contentWidth: offsetWidth,
            left: parentElement.offsetWidth,
        })
    }, [])

    const { contentWidth, left, duration: timing } = state

    const animationName = `marquee_${contentWidth}`

    const Text = styled.p`
    position: relative;
    left: ${left}px;
    animation: ${animationName} ${timing}s linear infinite both;
    animation-play-state: running;
    animation-fill-mode: forwards;

    @keyframes ${animationName} {
      0% {
        transform: translateX(0px);
      }

      100% {
        transform: translateX(-${contentWidth + left}px);
      }
    }
  `
    if (AppData.ServerConfig && AppData.ServerConfig.chat_show_url && AppData.ServerConfig.chat_show_url.length > 0) {
        return (
            <div className="marquee_box">
                <Text ref={ref}>
                    <span>{content + '防丢失请记住备用域名'}</span>
                    <a target="_blank" href={AppData.ServerConfig.chat_show_url}>{AppData.ServerConfig.chat_show_url}</a>
                    <span>或者下载APP</span>
                </Text>
            </div>
        )
    }
    return (
        <Grid className="marquee_box">
            <Text ref={ref}>
                {content}
            </Text>
        </Grid>
    )


}
TextScroll.defaultProps = {
    content: '',
    duration: 30,
}

export default React.memo(TextScroll)
